import { render, staticRenderFns } from "./ShowCompanyPage.vue?vue&type=template&id=8e90d9ae&scoped=true"
import script from "./ShowCompanyPage.vue?vue&type=script&lang=js"
export * from "./ShowCompanyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e90d9ae",
  null
  
)

export default component.exports